import React from "react";
import { Box, Chip } from "@mui/material";
import { getQuestionTypeIcon } from "./form-builder-shared";

/**
 * Renders a question identity row with a trailing type chip (MUI Autocomplete `renderOption`).
 */
export const renderQuestionIdentityOptionWithTypeChip = (
  questionIdentityLabelMap: Record<string, string>,
  questionIdentityTypeMap: Record<string, string>,
) =>
  (props: React.HTMLAttributes<HTMLLIElement>, option: string) => {
    const valueType = questionIdentityTypeMap[option] ?? "unknown";
    return (
      <li {...props}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
            py: 0.25,
          }}
        >
          <Box
            component="span"
            sx={{
              flex: 1,
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {questionIdentityLabelMap[option] || option}
          </Box>
          <Chip
            icon={getQuestionTypeIcon(valueType)}
            label={valueType}
            size="small"
            variant="outlined"
            sx={{
              flexShrink: 0,
              maxWidth: "45%",
              "& .MuiChip-icon": { ml: "4px" },
            }}
          />
        </Box>
      </li>
    );
  };

/**
 * Renders a catalog question name row with a trailing value-type chip (Question Name autocomplete).
 */
export const renderQuestionNameOptionWithTypeChip = (
  existingQuestions: Record<string, string>,
) =>
  (props: React.HTMLAttributes<HTMLLIElement>, option: string) => {
    const valueType = existingQuestions[option] ?? "unknown";
    return (
      <li {...props}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
            py: 0.25,
          }}
        >
          <Box
            component="span"
            sx={{
              flex: 1,
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {option}
          </Box>
          <Chip
            icon={getQuestionTypeIcon(valueType)}
            label={valueType}
            size="small"
            variant="outlined"
            sx={{
              flexShrink: 0,
              maxWidth: "45%",
              "& .MuiChip-icon": { ml: "4px" },
            }}
          />
        </Box>
      </li>
    );
  };
